// extracted by mini-css-extract-plugin
export var arrows = "_77-6";
export var decrementer = "_77-a";
export var disabled = "_77-4";
export var error = "_77-1";
export var hiddenText = "_77-b";
export var incrementer = "_77-9";
export var input = "_77-8";
export var inputWrapper = "_77-0";
export var leadingIcon = "_77-c";
export var readonly = "_77-3";
export var regular = "_77-7";
export var small = "_77-5";
export var warning = "_77-2";